import { RECOMMENDATION_MESSAGE } from './constants';
import { isCompletedOrFuturePickup } from '../../../../utils/utils';

const getFailedRecommendationAPIMessage = ({
  recommendAssignedUnassignedPickups,
  isManualRefresh,
}) => {
  if (recommendAssignedUnassignedPickups && !isManualRefresh) {
    return RECOMMENDATION_MESSAGE.FAILED.ENABLE_ASSIGN_RECOMMENDATION;
  } else if (isManualRefresh) {
    return RECOMMENDATION_MESSAGE.FAILED.MANUAL_REFRESH;
  }
  return RECOMMENDATION_MESSAGE.FAILED.UNKNOWN_ERROR;
};

const getFormattedPickupRecommendations = (recommendations, routesList) => {
  return recommendations.reduce((formattedRecommendations, recommendation) => {
    const matchingRoute = routesList.find(
      ({ routeId }) => recommendation.routeId?.toLowerCase() === routeId?.toLowerCase()
    ) ?? {};

    formattedRecommendations[recommendation.groupId?.toLowerCase()] = {
      routeId: matchingRoute.routeId,
      driverId: matchingRoute.driverId,
      driverName: matchingRoute.driverName,
      driverNumber: matchingRoute.driverNumber,
      recommendationNotes: recommendation.notes,
    };

    return formattedRecommendations;
  }, {});
};

const isAssignedDriverRecommendedAgain = (driverId, recommendationId) => {
  return driverId && recommendationId && driverId.toLowerCase() === recommendationId.toLowerCase();
};

const isValidPickupForRecommendationAssignment = (pickup, recommendationId) => {
  return !(
    isCompletedOrFuturePickup(pickup) ||
    isAssignedDriverRecommendedAgain(pickup.driverId, recommendationId)
  );
};

const getPayloadForReAssignedDriver = ({ payload, pickup, recommendationId }) => {
  if (isValidPickupForRecommendationAssignment(pickup, recommendationId)) {
    return {
      ...payload,
      reassignPickupsPayload: [
        ...payload.reassignPickupsPayload,
        {
          pickupId: pickup.pickupId,
          groupId: pickup.groupId,
          driverIdToAssign: recommendationId,
          driverIdToUnassign: pickup.driverId
        }
      ]
    };
  }
  return payload;
};

const getPayloadForAssignedDriver = ({ payload, pickup, recommendationId }) => {
  if (isValidPickupForRecommendationAssignment(pickup, recommendationId)) {
    return {
      ...payload,
      assignPickupsPayload: [
        ...payload.assignPickupsPayload,
        { pickupId: pickup.pickupId, groupId: pickup.groupId, driverId: recommendationId }
      ]
    };
  }
  return payload;
};

const getFormattedPayloadForAssignUnAssignPickups = (
  assignPickupDetails,
  reassignPickupDetails
) => {
  const convertPickupDetail = ({ pickupId, groupId, driverId, driverIdToAssign, driverIdToUnassign }) => ({
    pickupId,
    groupId,
    driverIdToAssign: driverId ?? driverIdToAssign,
    ...(driverIdToUnassign && { driverIdToUnassign })
  });
  const assignResult = assignPickupDetails.map(convertPickupDetail);
  const reassignResult = reassignPickupDetails.map(convertPickupDetail);
  return [...assignResult, ...reassignResult];
};


export {
  getFailedRecommendationAPIMessage,
  getFormattedPickupRecommendations,
  getPayloadForAssignedDriver,
  getPayloadForReAssignedDriver,
  isAssignedDriverRecommendedAgain,
  getFormattedPayloadForAssignUnAssignPickups,
};
